/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { CFMixins } from '../../mixins';
//
// Tokens
//
export const CFBaseTabTokens = {
    BORDER_COLORS: {
        ALTERNATE: {
            ACTIVE: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
            DEFAULT: 'transparent',
        },
        DEFAULT: {
            ACTIVE: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
            DEFAULT: 'transparent',
        },
    },
    BORDER_WIDTH: 2,
    TEXT_COLORS: {
        ALTERNATE: {
            ACTIVE: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
            DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_HINT,
        },
        DEFAULT: {
            ACTIVE: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
            DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
        },
    },
    TYPE_SPECS: {
        ACTIVE: CFTokens.TYPE_SPEC_SCALE.F_SEMIBOLD_AUTO,
        DEFAULT: CFTokens.TYPE_SPEC_SCALE.F_SEMIBOLD_AUTO,
    },
};
//
// Helpers
//
export const CFBaseTabHelpers = {
    borderColor: ({ $active, $alternateTheme, $customTheme, $withActiveBorder, }) => {
        let borderColor = CFBaseTabTokens.BORDER_COLORS[$alternateTheme ? 'ALTERNATE' : 'DEFAULT']
            .DEFAULT;
        if ($active && $withActiveBorder)
            borderColor =
                CFBaseTabTokens.BORDER_COLORS[$alternateTheme ? 'ALTERNATE' : 'DEFAULT']
                    .ACTIVE;
        if ($active && $withActiveBorder && ($customTheme === null || $customTheme === void 0 ? void 0 : $customTheme.activeBorderColor)) {
            borderColor = CFTokens.getCFColorValue($customTheme.activeBorderColor, borderColor);
        }
        return borderColor;
    },
    textColor: ({ $active, $alternateTheme, $customTheme, }) => {
        let textColor = CFBaseTabTokens.TEXT_COLORS[$alternateTheme ? 'ALTERNATE' : 'DEFAULT']
            .DEFAULT;
        if ($customTheme === null || $customTheme === void 0 ? void 0 : $customTheme.defaultColor)
            textColor = CFTokens.getCFColorValue($customTheme.defaultColor, textColor);
        if ($active)
            textColor =
                CFBaseTabTokens.TEXT_COLORS[$alternateTheme ? 'ALTERNATE' : 'DEFAULT']
                    .ACTIVE;
        if ($active && ($customTheme === null || $customTheme === void 0 ? void 0 : $customTheme.activeColor))
            textColor = CFTokens.getCFColorValue($customTheme.activeColor, textColor);
        return textColor;
    },
    typeSpec: ({ $active }) => $active
        ? CFMixins.typeSpec(CFBaseTabTokens.TYPE_SPECS.ACTIVE)
        : CFMixins.typeSpec(CFBaseTabTokens.TYPE_SPECS.DEFAULT),
};
//
// Element Styles
//
export const CFBaseTabStyles = {
    Label: css `
    ${CFBaseTabHelpers.typeSpec};
    color: ${CFBaseTabHelpers.textColor};
  `,
    LabelWrapper: css `
    padding: ${CFTokens.SPACER.B}px 0
      ${CFTokens.SPACER.B - CFBaseTabTokens.BORDER_WIDTH}px;
    min-height: 48px;
    display: flex;
    gap: ${CFTokens.SPACER.B}px;
    flex-direction: row;
    align-items: center;
    border-bottom-width: ${CFBaseTabTokens.BORDER_WIDTH}px;
    border-bottom-style: solid;
    border-bottom-color: ${CFBaseTabHelpers.borderColor};
  `,
    Root: css `
    padding: 0;
    display: flex;
    border: 0;
    background-color: transparent;
    text-align: center;
    justify-self: flex-start;
  `,
};
